import React, {HTMLAttributes} from 'react';
import {Message} from '@/api/dto/message';
import {useRosterStore} from '@/store/roster_store';
import {useAuthStore} from '@/store/auth_store';
import {NotificationLink} from '@/components/pages/notifications/links/NotificationLink';
import {SearchParam} from '@/helpers/search_params';
import PermissionsHelpers from '@/helpers/permissions_helpers';

type Props = HTMLAttributes<HTMLAnchorElement> & {
  message?: Message;
  disabled?: boolean;
};

export default function ReferralLink({ message, disabled, ...props }: Props) {
  const { currentRoster } = useRosterStore();
  const { currentUser } = useAuthStore();

  const referralId = message?.messageThread?.referralId || '';
  const searchParams = `${SearchParam.REFERRAL_ID}=${referralId}`;

  return !!currentUser && !!currentRoster && PermissionsHelpers.hasRosterAccess(currentUser, currentRoster) && referralId ? (
    <NotificationLink to={`/referrals?${searchParams}`} disabled={disabled} {...props}>
      new referral message
    </NotificationLink>
  ) : (
    <>new referral message</>
  );
}

